import React from 'react'
import { route } from "@helpers"
import { useMemo } from "react"
import { Link } from "react-router-dom"

export default function useSalonManagerHeading(salon: Admin.Models.Salon) {
    return useMemo(() => {
        return <><Link to={route("admin:salons")}>Salons</Link> — {salon.attrs.name()}</>
    }, [salon])
}